// Unpublished Work © 2020-2023 Deere & Company

import {
    fetchJson,
    fetch
} from '@deere/cap-it-ui.fetch';
import {oktaAuth} from '../../factories/okta-config-factory';
import {appendParamsToEndpoint} from './query-params';
import {store} from '../../factories/store-factory';
import {getLocaleAndCurrency} from '../../services/locale-and-currency';
import {isTokenExpired} from './token';
import {adaptLocaleDashToUnderscore} from '../adapters/user';
import {processEnvSvc} from '../../services/process-env-svc';

const getServiceApi = (api, params) => {
    const endpoint = processEnvSvc('API_URL') ? `${processEnvSvc('API_URL')}${api}` : api;

    return appendParamsToEndpoint(endpoint, params);
};

const getApplicationName = () => {
    const state = store.getState();
    const parentAppName = state.configuration.parentAppName;

    return {
        'Application-Name': parentAppName
    };
};

export const getFormattedLocale = (state) => {
    const {locale} = getLocaleAndCurrency(state.configuration, state.user);

    return adaptLocaleDashToUnderscore(locale);
};

const getHeaders = (version, token) => {
    const state = store.getState();
    const locale = getFormattedLocale(state);

    return {
        Authorization: `Bearer ${token}`,
        Accept: `application/${version}+json`,
        'Accept-Language': locale,
        ...getApplicationName()
    };
};

const getUserQueryParams = (businessActivities, withLocale) => {
    const state = store.getState();
    const {impersonateUserId} = state.user;

    return {
        ...businessActivities,
        locale: withLocale ? getFormattedLocale(state) : '',
        impersonateUserId
    };
};

export const Wrapper = (fetchToUse) =>
    async (endpoint, {
        businessActivities = {},
        withLocale = false,
        version = 'v1',
        ...fetchOptions
    } = {}) => {
        let token = oktaAuth.getAccessToken();

        if (isTokenExpired(token)) {
            await oktaAuth.tokenManager.renew('accessToken');
            token = oktaAuth.getAccessToken();
        }

        const options = {
            ...fetchOptions,
            headers: getHeaders(version, token)
        };

        return fetchToUse(
            getServiceApi(endpoint, getUserQueryParams(businessActivities, withLocale)),
            options
        );
    };

export const fetchJsonWrapper = Wrapper(fetchJson);
export const fetchWrapper = Wrapper(fetch);
